import setProgress from './set-progress';

export default {
  setProgress,
};
